<template>
  <UserProfileForm
    :user-profile="userProfile"
    :submit-label="$t('create_account')"
    :submit-icon="null"
    :is-loading="isLoading"
    :on-submit="createAccount"
  />
</template>

<script>
  import UserProfileForm from '../../components/forms/auth/UserProfile';

  export default {
    components: {
      UserProfileForm,
    },
    data() {
      return {
        stepBoxPos: {
          top: 58,
          right: 0,
        },
        userProfile: {
          firstName: '',
          lastName: '',
          title: '',
          email: '',
          password: '',
          language: 'en',
          timezone: 1,
        },
        isTypeDetermined: false,
        isLoading: false,
        isSubmitted: false,
      };
    },
    computed: {
      user() {
        return this.$store.getters['auth/user'];
      },
    },
    watch: {
      user: {
        immediate: true,
        handler(nextUser) {
          const {
            firstname = '',
            lastname = '',
            email,
            language = 'en',
          } = nextUser;

          this.userProfile = {
            ...this.userProfile,
            firstName: firstname,
            lastName: lastname,
            email,
            language,
          };
        },
      },
    },
    methods: {
      createAccount(userProfile) {
        const { token } = this.$route.params;
        const {
          firstName,
          lastName,
          title,
          email,
          password,
          language,
          timezone,
          acceptedTerms,
        } = userProfile;

        const user = {
          firstname: firstName,
          lastname: lastName,
          email,
          token,
          password,
          employee: title,
          language,
          timezone,
          terms_accepted: acceptedTerms,
        };

        this.isLoading = true;
        this.isSubmitted = true;

        return this.$store
          .dispatch('auth/registerInvited', user)
          .then((res) => {
            this.isLoading = false;
            this.isSubmitted = false;
            return res;
          })
          .catch(() => {
            this.isLoading = false;
            this.isSubmitted = false;
          });
      },
    },
    metaInfo() {
      return {
        title: this.$t('views_register_title'),
      };
    },
  };
</script>
